import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function PaymentFailed() {
    return (
        <Container sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h3" color="error" gutterBottom>
                Payment Failed
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
                There was an issue processing your payment. Please try again.
            </Typography>
            <Button
                variant="contained"
                color="error"
                component={Link}
                to="/dashboard"
            >
                Return to Dashboard
            </Button>
        </Container>
    );
}